import type { GetRecordListMenuItemsResponse, RecordListMenuItem } from '../../@types/record-list-menu';
import { api } from './api';

export const recordListMenuApi = api.enhanceEndpoints({ addTagTypes: ['PinnedMenuItems'] }).injectEndpoints({
  overrideExisting: 'throw',
  endpoints: (builder) => ({
    getPinnedRecordListMenuItems: builder.query<Array<RecordListMenuItem>, void>({
      query: () => '/record-list-menus',
      transformResponse: (response: GetRecordListMenuItemsResponse) => response.result ?? [],
      providesTags: ['PinnedMenuItems'],
    }),
    pinRecordListMenuItem: builder.mutation<void, RecordListMenuItem>({
      query: (menuItem) => ({
        url: '/record-list-menus/pin',
        method: 'POST',
        body: menuItem,
      }),
      invalidatesTags: ['PinnedMenuItems'],
    }),
    unpinRecordListMenuItem: builder.mutation<void, RecordListMenuItem>({
      query: (menuItem) => ({
        url: '/record-list-menus/unpin',
        method: 'POST',
        body: menuItem,
      }),
      invalidatesTags: ['PinnedMenuItems'],
    }),
  }),
});

export const {
  useGetPinnedRecordListMenuItemsQuery,
  usePinRecordListMenuItemMutation,
  useUnpinRecordListMenuItemMutation,
} = recordListMenuApi;
